<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">集装箱调整履历</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search">search</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <v-text-field
                clearable
                label="ContainerNo"
                v-model="query.containerNo"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="operatorName"
                v-model="query.operatorName"
              />
            </v-flex>
            <!-- <v-flex xs3>
              <v-text-field clearable label="Status" v-model="query.status" />
            </v-flex> -->
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10, 20, 50, 100, 200, 500, 1000]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected[pagination.page]"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.operatorName }}</td>
          <td>{{ props.item.operationDate }}</td>
          <td>{{ props.item.containerNo }}</td>
          <td>{{ props.item.sourceFinallyWarehouseName }}</td>
          <td>{{ props.item.sourceForecastDeliveryDate }}</td>
          <td>{{ props.item.targetFinallyWarehouseName }}</td>
          <td>{{ props.item.targetForecastDeliveryDate }}</td>
          <td>{{ props.item.status }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
      results: [],
      pagination: {
        rowsPerPage: 10,
      },
      loading: false,
      query: { yearMonth: '' },
      headers: [
        {
          text: '操作人',
          value: 'operatorName',
          sortable: false,
        },
        {
          text: '操作时间',
          value: 'operationDate',
          sortable: false,
        },
        {
          text: '集装箱号码',
          value: 'containerNo',
          sortable: false,
        },
        {
          text: '源仓库名',
          value: 'sourceFinallyWarehouseName',
          sortable: false,
        },
        {
          text: '源预定时间',
          value: 'sourceForecastDeliveryDate',
          sortable: false,
        },
        {
          text: '目标仓库名',
          value: 'targetFinallyWarehouseName',
          sortable: false,
        },
        {
          text: '目标预定时间',
          value: 'targetForecastDeliveryDate',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: 'operationDate,desc',
        },
      }
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/operations/adjust-container', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
